import React from "react";

import { Box } from "@intechprev/componentes-web";
import { CalendarioPagamentoEntidade } from "../../../../entidades";

interface IProps {
  calendario: CalendarioPagamentoEntidade[] | null
}

export const CalendarioPagamento: React.FC<IProps> = ({
  calendario
}) => {

  if (calendario !== null && calendario !== undefined && calendario.length > 0) {
    return (
      <Box titulo={"Calendário de Pagamento"}>
        <div className={"table-responsive"}>
          <table className={"table table-striped table-sm"}>
            <tbody>
              {calendario.map((data: CalendarioPagamentoEntidade, index: number) => {
                return (
                  <tr key={index}>
                    <td>{data.DES_MES}</td>
                    <td className={"text-right"}>{data.NUM_DIA}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </Box>
    )
  }

  return (
    null
  );
}